export const selectAuthInfo = (state: any) => state.auth;